import type { IWebsitesFavicons } from "app/services/sitesService/types";

import { useSelectedGroupItemStore } from "../../../common/modal/useSelectedGroupItemStore";
import type { AdsAlertGroup } from "../../types";

import { AdsAlertModalInner } from "./AdsAlertModalInner";

interface IAdsAlertModalProps {
    favicons?: IWebsitesFavicons;
    groups: AdsAlertGroup[];
}

export const AdsAlertModal = ({ favicons, groups }: IAdsAlertModalProps) => {
    const selectedGroupIndex = useSelectedGroupItemStore((store) => store.selectedGroupIndex);

    if (selectedGroupIndex == null) {
        return null;
    }

    const group = groups[selectedGroupIndex];

    if (!group || !group.ads.length || (group.groupType !== "Display" && group.groupType !== "Social")) {
        return null;
    }

    return (
        <AdsAlertModalInner
            favicon={favicons?.[group.domain] ?? ""}
            group={group}
        />
    );
};
